import { isSayWeeeApp } from '@/utils/weeeapp';
import { useEffect, useRef, useMemo, useReducer } from 'react';
import { useInView, IntersectionOptions } from 'react-intersection-observer';

type BizOptions = {
  inviewCallBack?: (data: Record<string, any>) => void;
  data?: Record<string, any>;
};
/**
 *
 * @param options 指定元素进入视窗内1s后触发
 * @returns
 */
function useSectionInView(inviewOptions: IntersectionOptions, bizOptions: BizOptions) {
  const { ref, inView, entry } = useInView({
    threshold: 0.5,
    ...inviewOptions
  });
  const [_ignored, forceUpdate] = useReducer(x => x + 1, 0);
  const refReported = useRef<boolean>();
  const timer = useRef(null);
  const fnRef = useRef(bizOptions?.inviewCallBack);
  fnRef.current = useMemo(() => {
    return bizOptions?.inviewCallBack;
  }, [bizOptions?.inviewCallBack]);

  useEffect(() => {
    if (inView) {
      if (refReported.current) return;
      timer.current = setTimeout(() => {
        refReported.current = true;
        if (bizOptions?.inviewCallBack) {
          fnRef.current?.(bizOptions?.data);
        }
      }, 1000);
    } else {
      clearTimeout(timer.current);
    }
    return () => clearTimeout(timer.current);
  }, [inView]);

  useEffect(() => {
    const handleImpression = () => {
      refReported.current = false;
      forceUpdate();
    };
    if (isSayWeeeApp()) {
      document.addEventListener('onPageResume', handleImpression);
    }
    return () => {
      if (isSayWeeeApp()) {
        document.removeEventListener('onPageResume', handleImpression);
      }
    };
  }, []);

  return { ref, inView, entry };
}

export default useSectionInView;
